import React, { useState, useEffect } from 'react';

const API_BASE = 'https://api.insightsengine.org';

const content = {
  en: {
    appTitle: 'INSIGHT ENGINE',
    pageTitle: 'Configure Your Briefing',
    pageSubtitle: 'Tell us about your role and interests to receive your personalized intelligence briefing.',
    industry: 'Industry',
    industryPlaceholder: 'Select your industry',
    jobTitle: 'Job Title',
    jobTitlePlaceholder: 'e.g. Marketing Manager, Sales Director, Operations Lead',
    roleDescription: 'Role Description',
    roleDescriptionPlaceholder: 'Briefly describe your responsibilities, team size, and what you are accountable for. The more specific, the better your briefing.',
    roleDescriptionOptional: '(optional — makes your briefing more specific)',
    focusAreas: 'Focus Areas',
    focusAreasPlaceholder: 'e.g. regulatory changes, competitor moves, Vision 2030 projects',
    geography: 'Geographic Coverage',
    goals: 'Your Goals or KPIs',
    goalsOptional: '(optional — makes your briefing more specific)',
    goalsPlaceholder: 'e.g. Grow syndicated loan book by SAR 2bn, onboard 5 new corporate clients in energy sector',
    frequency: 'Briefing Frequency',
    daily: 'Daily',
    weekly: 'Weekly',
    onDemand: 'On Demand',
    generateButton: 'Generate My Briefing',
    generatingButton: 'Generating...',
    loadingMessage: 'Generating your briefing... this may take a few seconds.',
    briefingTitle: 'Your',
    briefingTitleSuffix: 'Briefing',
    regenerate: 'Regenerate Briefing',
    downloadPdf: 'Download as PDF',
    addDetail: '+ Add more detail (optional, improves accuracy)',
    hideDetail: '− Hide extra detail',
    welcomeBack: 'Welcome back',
    quickGenerateSubtitle: 'Your profile is saved. Generate today\'s briefing in one click.',
    editProfile: 'Edit profile',
    quickIndustryLabel: 'Industry',
    quickRoleLabel: 'Role',
    disclaimer: 'Briefing generated from publicly available knowledge. For real-time market data, upgrade to Professional.',
    nav: { briefing: 'My Briefing', settings: 'Settings', about: 'About' },
    industries: ['Financial Services', 'Banking', 'Real Estate', 'Energy & Oil and Gas', 'Technology & IT', 'Healthcare', 'Telecommunications', 'Retail & E-commerce', 'Manufacturing', 'Construction', 'Consulting', 'Government & Public Sector', 'Logistics & Transportation', 'Education', 'Hospitality & Tourism', 'Media & Entertainment', 'Insurance', 'Legal Services', 'Automotive', 'Agriculture', 'Other'],
    geoOptions: [
      { value: 'Saudi Arabia', label: 'Saudi Arabia' },
      { value: 'GCC', label: 'GCC' },
      { value: 'Middle East and North Africa', label: 'MENA' },
      { value: 'Europe', label: 'Europe' },
      { value: 'Global', label: 'Global' },
    ],
  },
  ar: {
    appTitle: 'INSIGHT ENGINE',
    pageTitle: 'إعداد نشرتك الذكية',
    pageSubtitle: 'أخبرنا عن دورك واهتماماتك لتلقي نشرتك الشخصية.',
    industry: 'القطاع',
    industryPlaceholder: 'اختر قطاعك',
    jobTitle: 'المسمى الوظيفي',
    jobTitlePlaceholder: 'مثال: مدير تسويق، مدير مبيعات، رئيس العمليات',
    roleDescription: 'وصف الدور الوظيفي',
    roleDescriptionPlaceholder: 'صف مسؤولياتك وحجم فريقك وما تقوم بالإشراف عليه.',
    roleDescriptionOptional: '(اختياري — يجعل نشرتك أكثر تخصصاً)',
    focusAreas: 'مجالات الاهتمام',
    focusAreasPlaceholder: 'مثال: التغييرات التنظيمية، تحركات المنافسين، مشاريع رؤية 2030',
    geography: 'النطاق الجغرافي',
    goals: 'أهدافك أو مؤشرات الأداء',
    goalsOptional: '(اختياري — يجعل نشرتك أكثر تخصصاً)',
    goalsPlaceholder: 'مثال: تنمية محفظة القروض المشتركة بمقدار 2 مليار ريال',
    frequency: 'تكرار النشرة',
    daily: 'يومي',
    weekly: 'أسبوعي',
    onDemand: 'عند الطلب',
    generateButton: 'إنشاء نشرتي',
    generatingButton: 'جاري الإنشاء...',
    loadingMessage: 'جاري إنشاء نشرتك... قد يستغرق ذلك بضع ثوانٍ.',
    briefingTitle: 'نشرتك',
    briefingTitleSuffix: '',
    regenerate: 'إعادة الإنشاء',
    downloadPdf: 'تنزيل كملف PDF',
    addDetail: '+ إضافة تفاصيل (اختياري، يحسّن الدقة)',
    hideDetail: '− إخفاء التفاصيل',
    welcomeBack: 'مرحباً بعودتك',
    quickGenerateSubtitle: 'ملفك الشخصي محفوظ. أنشئ نشرة اليوم بنقرة واحدة.',
    editProfile: 'تعديل الملف الشخصي',
    quickIndustryLabel: 'القطاع',
    quickRoleLabel: 'الدور',
    disclaimer: 'النشرة مولّدة من المعلومات المتاحة للعموم. للحصول على بيانات السوق الفورية، يرجى الترقية إلى الخطة الاحترافية.',
    nav: { briefing: 'نشرتي', settings: 'الإعدادات', about: 'عن التطبيق' },
    industries: ['الخدمات المالية', 'البنوك', 'العقارات', 'الطاقة والنفط والغاز', 'التقنية وتكنولوجيا المعلومات', 'الرعاية الصحية', 'الاتصالات', 'التجزئة والتجارة الإلكترونية', 'الصناعة والتصنيع', 'الإنشاءات', 'الاستشارات', 'الحكومة والقطاع العام', 'اللوجستيات والنقل', 'التعليم', 'الضيافة والسياحة', 'الإعلام والترفيه', 'التأمين', 'الخدمات القانونية', 'صناعة السيارات', 'الزراعة', 'أخرى'],
    geoOptions: [
      { value: 'Saudi Arabia', label: 'المملكة العربية السعودية' },
      { value: 'GCC', label: 'دول الخليج' },
      { value: 'Middle East and North Africa', label: 'الشرق الأوسط وشمال أفريقيا' },
      { value: 'Europe', label: 'أوروبا' },
      { value: 'Global', label: 'عالمي' },
    ],
  },
};

// Shared brand tokens, used by both the personal app and the department portal.
const BRAND = {
  ink: '#16131C',
  paper: '#FDFBF9',
  violet: '#6C4FE0',
  headFont: "'Bricolage Grotesque', Georgia, serif",
  bodyFont: "'Inter', Arial, sans-serif",
};

// Turns the briefing's markdown-ish text into styled JSX blocks. Shared by the
// personal briefing view and the department portal view — isArabic is passed
// in explicitly since this no longer lives inside a component closure.
function formatBriefing(text, isArabic) {
  const rawLines = text.split('\n');
  const blocks = [];
  let current = null;

  rawLines.forEach((line) => {
    const trimmed = line.trim();
    const strippedLeadingStars = trimmed.replace(/^\*+/, '');
    const isNumbered = /^\d+\./.test(strippedLeadingStars);
    const isHeading = trimmed.startsWith('# ') || trimmed.startsWith('## ') || trimmed.startsWith('### ');

    const isBoldTitle = trimmed.startsWith('**') && trimmed.endsWith('**') && trimmed.length > 4;

    if (isNumbered) {
      if (current) blocks.push(current);
      current = { type: 'insight', lines: [trimmed] };
    } else if (isHeading) {
      if (current) blocks.push(current);
      blocks.push({ type: 'heading', lines: [trimmed] });
      current = null;
    } else if (isBoldTitle) {
      if (current) blocks.push(current);
      current = { type: 'titled', lines: [trimmed] };
    } else if (trimmed === '' || trimmed === '---') {
      // ignore blank separators — don't break an insight block just because of a blank line
    } else if (current) {
      current.lines.push(trimmed);
    } else {
      blocks.push({ type: 'other', lines: [trimmed] });
    }
  });
  if (current) blocks.push(current);

  const icons = { matters: '🎯', action: '✅', monitor: '👁️' };

  const mergeContinuations = (lines) => {
    const segments = [];
    lines.forEach((line) => {
      if (line.startsWith('> ')) {
        segments.push(line);
      } else if (segments.length > 0) {
        segments[segments.length - 1] = segments[segments.length - 1] + ' ' + line;
      } else {
        segments.push(line);
      }
    });
    return segments;
  };

  const renderCallout = (raw, kind) => {
    const cleanMap = {
      matters: { en: /^Why It Matters:\s*/i, ar: /^لماذا يهم:\s*/i, label: isArabic ? 'لماذا يهم' : 'Why It Matters', color: '#6C4FE0' },
      action: { en: /^Action:\s*/i, ar: /^إجراء مقترح:\s*/i, label: isArabic ? 'إجراء مقترح' : 'Action', color: '#1A6B3A' },
      monitor: { en: /^Monitor:\s*/i, ar: /^راقب:\s*/i, label: isArabic ? 'راقب' : 'Monitor', color: '#16131C' },
    };
    const cfg = cleanMap[kind];
    const cleaned = raw.replace(cfg.en, '').replace(cfg.ar, '');
    return (
      <div style={{ display: 'flex', gap: '8px', backgroundColor: '#FAFAFA', padding: '10px 12px', marginTop: '8px', borderRadius: '6px', fontSize: '13px', lineHeight: '1.6', color: '#444444' }}>
        <span style={{ fontSize: '15px', flexShrink: 0 }}>{icons[kind]}</span>
        <span><span style={{ fontWeight: 'bold', color: cfg.color }}>{cfg.label}: </span>{cleaned}</span>
      </div>
    );
  };

  const SOURCE_LINK_RE = /^\[(.+?)\]\((https?:\/\/[^\s)]+)\)\s*$/;
  const renderSource = (clean, key) => {
    const sourceRe = isArabic ? /^المصدر:\s*/i : /^Source:\s*/i;
    if (!sourceRe.test(clean)) return null;
    const label = isArabic ? 'المصدر' : 'Source';
    const body = clean.replace(sourceRe, '').trim();
    const linkMatch = body.match(SOURCE_LINK_RE);
    if (linkMatch) {
      const [, pubName, url] = linkMatch;
      return (
        <div key={key} style={{ fontSize: '11px', marginTop: '8px' }}>
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#6C4FE0', fontWeight: 'bold', textDecoration: 'none' }}>
            {label}: {pubName} ↗
          </a>
        </div>
      );
    }
    return <div key={key} style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>{label}: {body}</div>;
  };

  let insightCount = 0;

  return blocks.map((block, bIndex) => {
    if (block.type === 'heading') {
      const line = block.lines[0];
      if (line.startsWith('# ')) {
        return <div key={bIndex} style={{ color: '#16131C', fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>{line.replace(/^# /, '')}</div>;
      }
      return <div key={bIndex} style={{ color: '#16131C', fontSize: '14px', fontWeight: 'bold', marginTop: '28px', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>{line.replace(/^##+ /, '').replace(/\*\*/g, '')}</span>
        <span style={{ flex: 1, height: '1px', backgroundColor: '#E5E5E5' }} />
      </div>;
    }

    if (block.type === 'titled') {
      const rawTitle = block.lines[0].replace(/^\*\*/, '').replace(/\*\*$/, '');
      const tagMatch = rawTitle.match(/\[(.*?)\]\s*$/);
      const tag = tagMatch ? tagMatch[0] : null;
      const titleLine = tag ? rawTitle.replace(tag, '').trim() : rawTitle;
      const isRisk = /^Risk:/i.test(titleLine) || /^مخاطر:/i.test(titleLine) || /^خطر:/i.test(titleLine);
      const icon = isRisk ? '⚠️' : '📌';
      const accent = isRisk ? '#D6503C' : '#16131C';
      const mergedLines = mergeContinuations(block.lines.slice(1));
      const callouts = mergedLines.filter(l => l.startsWith('> '));
      const plainLines = mergedLines.filter(l => !l.startsWith('> '));

      return (
        <div key={bIndex} style={{ display: 'flex', gap: '14px', backgroundColor: isRisk ? '#FDEAE6' : '#FFFFFF', border: `1px solid ${isRisk ? '#E3CFC5' : '#EEEEEE'}`, borderRadius: '10px', padding: '18px', marginTop: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ flexShrink: 0, fontSize: '20px' }}>{icon}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
              <span style={{ color: accent, fontSize: '15px', fontWeight: '700' }}>{titleLine}</span>
              {tag && <span style={{ backgroundColor: '#FBF0DE', color: '#B9791E', fontSize: '11px', fontWeight: 'bold', padding: '2px 8px', borderRadius: '12px' }}>{tag.replace(/[[\]]/g, '')}</span>}
            </div>
            {plainLines.map((line, i) => (
              <div key={`p-${i}`} style={{ fontSize: '13px', color: '#666', marginTop: '6px', lineHeight: '1.6' }}>{line}</div>
            ))}
            {callouts.map((raw, i) => {
              const clean = raw.replace(/^> /, '').replace(/\*\*/g, '');
              if (/^Why It Matters:/i.test(clean) || /^لماذا يهم:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'matters')}</React.Fragment>;
              if (/^Action:/i.test(clean) || /^إجراء مقترح:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'action')}</React.Fragment>;
              if (/^Monitor:/i.test(clean) || /^راقب:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'monitor')}</React.Fragment>;
              const sourceEl = renderSource(clean, i);
              if (sourceEl) return sourceEl;
              return <div key={i} style={{ fontSize: '13px', color: '#666', marginTop: '6px' }}>{clean}</div>;
            })}
          </div>
        </div>
      );
    }

    if (block.type === 'insight') {
      insightCount += 1;
      const titleLine = block.lines[0];
      const cnt = titleLine.replace(/^\*+/, '').replace(/\*+$/, '').replace(/\*\*/g, '');
      const tagMatch = cnt.match(/\[(.*?)\]/);
      const tag = tagMatch ? tagMatch[0] : null;
      const titleText = (tag ? cnt.replace(tag, '').trim() : cnt).replace(/^\d+\.\s*/, '');

      const mergedLines = mergeContinuations(block.lines.slice(1));
      const callouts = mergedLines.filter(l => l.startsWith('> '));
      const contextLines = mergedLines.filter(l => !l.startsWith('> '));

      return (
        <div key={bIndex} style={{ display: 'flex', gap: '14px', backgroundColor: '#FFFFFF', border: '1px solid #EEEEEE', borderRadius: '10px', padding: '18px', marginTop: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ flexShrink: 0, width: '30px', height: '30px', borderRadius: '50%', backgroundColor: '#16131C', color: '#6C4FE0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: 'bold' }}>
            {insightCount}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
              <span style={{ color: '#16131C', fontSize: '15px', fontWeight: '700' }}>{titleText}</span>
              {tag && <span style={{ backgroundColor: '#FBF0DE', color: '#B9791E', fontSize: '11px', fontWeight: 'bold', padding: '2px 8px', borderRadius: '12px' }}>{tag.replace(/[[\]]/g, '')}</span>}
            </div>
            {contextLines.map((line, i) => (
              <div key={`ctx-${i}`} style={{ fontSize: '13px', color: '#666', marginTop: '6px', lineHeight: '1.6' }}>{line}</div>
            ))}
            {callouts.map((raw, i) => {
              const clean = raw.replace(/^> /, '').replace(/\*\*/g, '');
              if (/^Why It Matters:/i.test(clean) || /^لماذا يهم:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'matters')}</React.Fragment>;
              if (/^Action:/i.test(clean) || /^إجراء مقترح:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'action')}</React.Fragment>;
              if (/^Monitor:/i.test(clean) || /^راقب:/i.test(clean)) return <React.Fragment key={i}>{renderCallout(clean, 'monitor')}</React.Fragment>;
              const sourceEl = renderSource(clean, i);
              if (sourceEl) return sourceEl;
              return <div key={i} style={{ fontSize: '13px', color: '#666', marginTop: '6px' }}>{clean}</div>;
            })}
          </div>
        </div>
      );
    }

    // 'other' plain paragraph block
    return block.lines.map((line, i) => {
      if (line.startsWith('**') && line.endsWith('**') && line.length > 4) {
        return <div key={`${bIndex}-${i}`} style={{ color: '#16131C', fontWeight: 'bold', fontSize: '14px', marginTop: '12px', marginBottom: '4px' }}>{line.replace(/\*\*/g, '')}</div>;
      }
      const cleaned = line.replace(/\*\*/g, '').replace(/\*/g, '');
      if (!cleaned) return null;
      return <div key={`${bIndex}-${i}`} style={{ color: '#444444', fontSize: '14px', lineHeight: '1.7', marginTop: '4px' }}>{cleaned}</div>;
    });
  });
}

function PersonalApp() {
  const [lang, setLang] = useState('en');
  const [industry, setIndustry] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [focusAreas, setFocusAreas] = useState('');
  const [selectedGeos, setSelectedGeos] = useState(['Saudi Arabia']);
  const [goals, setGoals] = useState('');
  const [loading, setLoading] = useState(false);
  const [briefing, setBriefing] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [editingProfile, setEditingProfile] = useState(true);
  const [hasSavedProfile, setHasSavedProfile] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('insightEngineProfile');
      if (saved) {
        const p = JSON.parse(saved);
        if (p.industry) setIndustry(p.industry);
        if (p.jobTitle) setJobTitle(p.jobTitle);
        if (p.roleDescription) setRoleDescription(p.roleDescription);
        if (p.focusAreas) setFocusAreas(p.focusAreas);
        if (p.goals) setGoals(p.goals);
        if (p.selectedGeos) setSelectedGeos(p.selectedGeos);
        setHasSavedProfile(true);
        setEditingProfile(false);
      }
    } catch (e) {
      // localStorage unavailable or corrupted — just fall back to the empty form
    }
  }, []);

  const saveProfile = () => {
    try {
      localStorage.setItem('insightEngineProfile', JSON.stringify({
        industry, jobTitle, roleDescription, focusAreas, goals, selectedGeos,
      }));
    } catch (e) {
      // ignore storage errors, non-critical
    }
  };

  const t = content[lang];
  const isArabic = lang === 'ar';

  const toggleGeo = (value) => {
    setSelectedGeos(prev =>
      prev.includes(value) ? prev.filter(g => g !== value) : [...prev, value]
    );
  };

  const callBriefingAPI = async () => {
    setLoading(true);
    setBriefing('');
    const geography = selectedGeos.join(', ');
    const role = jobTitle + (roleDescription ? ' — ' + roleDescription : '');
    try {
      const response = await fetch(
        `${API_BASE}/api/briefing`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ industry, role, focusAreas, goals, geography, language: lang }),
        }
      );
      const data = await response.json();
      if (data.success) setBriefing(data.briefing);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!industry || !jobTitle || !focusAreas) return;
    setMenuOpen(false);
    saveProfile();
    setHasSavedProfile(true);
    setEditingProfile(false);
    callBriefingAPI();
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: "'Inter', Arial, sans-serif", direction: isArabic ? 'rtl' : 'ltr' },
    header: { backgroundColor: '#16131C', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap' },
    headerLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
    hamburger: { display: 'none', background: 'transparent', border: '1px solid #6C4FE0', color: '#6C4FE0', fontSize: '18px', borderRadius: '4px', padding: '4px 10px', cursor: 'pointer' },
    headerTitle: { color: '#FFFFFF', fontSize: '20px', fontWeight: 'bold', letterSpacing: '0.3px', margin: 0, fontFamily: "'Bricolage Grotesque', Georgia, serif" },
    langToggle: { display: 'flex', gap: '8px' },
    langBtn: (active) => ({ backgroundColor: active ? '#6C4FE0' : 'transparent', color: active ? '#16131C' : '#6C4FE0', border: '1px solid #6C4FE0', padding: '4px 14px', fontSize: '13px', fontWeight: 'bold', borderRadius: '4px', cursor: 'pointer' }),
    body: { display: 'flex', flex: 1, overflow: 'hidden', position: 'relative' },
    sidebar: { width: '220px', minWidth: '220px', backgroundColor: '#16131C', padding: '24px 16px', display: 'flex', flexDirection: 'column', gap: '12px' },
    sidebarItem: { color: '#6C4FE0', fontSize: '14px', padding: '10px 12px', borderRadius: '6px', cursor: 'pointer', backgroundColor: 'rgba(108, 79, 224, 0.12)', textAlign: isArabic ? 'right' : 'left' },
    overlay: { display: 'none' },
    main: { flex: 1, backgroundColor: '#FDFBF9', padding: '32px', overflowY: 'auto', minWidth: 0 },
    mainTitle: { color: '#16131C', fontSize: '24px', fontWeight: 'bold', marginBottom: '8px', fontFamily: "'Bricolage Grotesque', Georgia, serif" },
    mainSubtitle: { color: '#666666', fontSize: '15px', marginBottom: '32px' },
    formGroup: { marginBottom: '24px' },
    label: { display: 'block', color: '#16131C', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' },
    optionalTag: { fontSize: '11px', color: '#999999', fontWeight: 'normal', marginLeft: isArabic ? '0' : '6px', marginRight: isArabic ? '6px' : '0' },
    select: { width: '100%', maxWidth: '480px', padding: '10px 12px', fontSize: '14px', border: '1px solid #CCCCCC', borderRadius: '6px', color: '#333333', backgroundColor: '#FFFFFF', boxSizing: 'border-box' },
    input: { width: '100%', maxWidth: '480px', padding: '10px 12px', fontSize: '14px', border: '1px solid #CCCCCC', borderRadius: '6px', color: '#333333', boxSizing: 'border-box' },
    textarea: { width: '100%', maxWidth: '480px', padding: '10px 12px', fontSize: '14px', border: '1px solid #CCCCCC', borderRadius: '6px', color: '#333333', boxSizing: 'border-box', resize: 'vertical', minHeight: '72px', fontFamily: 'Arial, sans-serif' },
    geoGrid: { display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '480px' },
    geoChip: (active) => ({ padding: '6px 14px', borderRadius: '20px', fontSize: '13px', cursor: 'pointer', border: active ? '2px solid #16131C' : '2px solid #CCCCCC', backgroundColor: active ? '#16131C' : '#FFFFFF', color: active ? '#6C4FE0' : '#666666', fontWeight: active ? 'bold' : 'normal', userSelect: 'none' }),
    radioGroup: { display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' },
    radioLabel: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#333333', cursor: 'pointer' },
    submitButton: { backgroundColor: '#16131C', color: '#FFFFFF', border: 'none', padding: '12px 32px', fontSize: '15px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer', marginTop: '8px', opacity: loading ? 0.7 : 1 },
    regenerateButton: { backgroundColor: 'transparent', color: '#16131C', border: '2px solid #16131C', padding: '10px 24px', fontSize: '14px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer' },
    pdfButton: { backgroundColor: '#16131C', color: '#FFFFFF', border: 'none', padding: '10px 24px', fontSize: '14px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer' },
    actionRow: { display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '16px' },
    loadingMessage: { marginTop: '24px', padding: '16px', backgroundColor: '#EFECFC', borderRadius: '6px', color: '#16131C', fontSize: '15px', fontStyle: 'italic', maxWidth: '480px' },
    briefingCard: { marginTop: '32px', backgroundColor: '#FFFFFF', borderRadius: '8px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: isArabic ? 'none' : '4px solid #6C4FE0', borderRight: isArabic ? '4px solid #6C4FE0' : 'none', padding: '32px', maxWidth: '760px', boxSizing: 'border-box' },
    briefingHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '16px', borderBottom: '2px solid #F0F0F0', flexWrap: 'wrap', gap: '8px' },
    briefingTitle: { color: '#16131C', fontSize: '18px', fontWeight: 'bold', margin: 0, fontFamily: "'Bricolage Grotesque', Georgia, serif" },
    briefingLogo: { color: '#6C4FE0', fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' },
    disclaimer: { marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #EEEEEE', color: '#999999', fontSize: '12px', fontStyle: 'italic' },
    divider: { border: 'none', borderTop: '1px dashed #DDDDDD', margin: '8px 0 24px 0', maxWidth: '480px' },
    showMoreLink: { background: 'transparent', border: 'none', color: '#16131C', fontSize: '13px', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', padding: '4px 0', marginBottom: '8px' },
    quickView: { maxWidth: '480px' },
    quickProfileCard: { backgroundColor: '#FFFFFF', border: '1px solid #E5E5E5', borderRadius: '10px', padding: '16px 20px', marginBottom: '20px' },
    quickProfileRow: { display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '14px' },
    quickProfileLabel: { color: '#999999', fontWeight: 'bold' },
    quickProfileValue: { color: '#16131C', fontWeight: '600', textAlign: isArabic ? 'left' : 'right' },
  };

  return (
    <div className="ie-container" style={styles.container}>
      {/* Responsive rules: on narrow screens the sidebar becomes a slide-out drawer */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700&family=Inter:wght@400;500;600&display=swap');
        @media (max-width: 768px) {
          .ie-hamburger { display: inline-block !important; }
          .ie-sidebar {
            position: fixed;
            top: 0;
            ${isArabic ? 'right' : 'left'}: 0;
            height: 100vh;
            z-index: 40;
            transform: translateX(${isArabic ? '100%' : '-100%'});
            transition: transform 0.25s ease;
            box-shadow: 2px 0 12px rgba(0,0,0,0.25);
          }
          .ie-sidebar.open {
            transform: translateX(0);
          }
          .ie-overlay.open {
            display: block !important;
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.4);
            z-index: 30;
          }
          .ie-main {
            width: 100%;
            padding: 20px 16px !important;
          }
        }
        @media print {
          .ie-no-print { display: none !important; }
          .ie-sidebar { display: none !important; }
          .ie-main { padding: 0 !important; }
          .ie-briefing-card {
            box-shadow: none !important;
            max-width: 100% !important;
            margin: 0 !important;
          }
          body, .ie-container { height: auto !important; overflow: visible !important; }
        }
      `}</style>
      <header className="ie-no-print" style={styles.header}>
        <div style={styles.headerLeft}>
          <button
            className="ie-hamburger"
            style={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
          <span style={{ display: 'inline-block', width: '9px', height: '9px', borderRadius: '50%', backgroundColor: '#6C4FE0', marginRight: isArabic ? 0 : '4px', marginLeft: isArabic ? '4px' : 0 }} />
          <h1 style={styles.headerTitle}>{t.appTitle}</h1>
        </div>
        <div style={styles.langToggle}>
          <button style={styles.langBtn(lang === 'en')} onClick={() => setLang('en')}>EN</button>
          <button style={styles.langBtn(lang === 'ar')} onClick={() => setLang('ar')}>عربي</button>
        </div>
      </header>
      <div style={styles.body}>
        <div
          className={`ie-overlay ${menuOpen ? 'open' : ''}`}
          style={styles.overlay}
          onClick={() => setMenuOpen(false)}
        />
        <aside className={`ie-sidebar ${menuOpen ? 'open' : ''}`} style={styles.sidebar}>
          <div style={styles.sidebarItem} onClick={() => setMenuOpen(false)}>{t.nav.briefing}</div>
          <div style={styles.sidebarItem} onClick={() => setMenuOpen(false)}>{t.nav.settings}</div>
          <div style={styles.sidebarItem} onClick={() => setMenuOpen(false)}>{t.nav.about}</div>
        </aside>
        <main className="ie-main" style={styles.main}>
          <div className="ie-no-print">
          {(editingProfile || !hasSavedProfile) ? (
          <>
          <h2 style={styles.mainTitle}>{t.pageTitle}</h2>
          <p style={styles.mainSubtitle}>{t.pageSubtitle}</p>

          <div style={styles.formGroup}>
            <label style={styles.label}>{t.industry}</label>
            <select style={styles.select} value={industry} onChange={(e) => setIndustry(e.target.value)}>
              <option value="">{t.industryPlaceholder}</option>
              {t.industries.map((ind, i) => (
                <option key={i} value={content.en.industries[i]}>{ind}</option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>{t.jobTitle}</label>
            <input type="text" placeholder={t.jobTitlePlaceholder} style={styles.input} value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>{t.focusAreas}</label>
            <input type="text" placeholder={t.focusAreasPlaceholder} style={styles.input} value={focusAreas} onChange={(e) => setFocusAreas(e.target.value)} />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>{t.geography}</label>
            <div style={styles.geoGrid}>
              {t.geoOptions.map((geo, i) => (
                <div key={i} style={styles.geoChip(selectedGeos.includes(geo.value))} onClick={() => toggleGeo(geo.value)}>
                  {geo.label}
                </div>
              ))}
            </div>
          </div>

          <button type="button" style={styles.showMoreLink} onClick={() => setShowMore(!showMore)}>
            {showMore ? t.hideDetail : t.addDetail}
          </button>

          {showMore && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>
                  {t.roleDescription}
                  <span style={styles.optionalTag}>{t.roleDescriptionOptional}</span>
                </label>
                <textarea placeholder={t.roleDescriptionPlaceholder} style={styles.textarea} value={roleDescription} onChange={(e) => setRoleDescription(e.target.value)} />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>
                  {t.goals}
                  <span style={styles.optionalTag}>{t.goalsOptional}</span>
                </label>
                <textarea placeholder={t.goalsPlaceholder} style={styles.textarea} value={goals} onChange={(e) => setGoals(e.target.value)} />
              </div>
            </>
          )}

          <hr style={styles.divider} />


          <button style={styles.submitButton} onClick={handleSubmit} disabled={loading}>
            {loading ? t.generatingButton : t.generateButton}
          </button>

          {loading && <div style={styles.loadingMessage}>{t.loadingMessage}</div>}
          </>
          ) : (
          <div style={styles.quickView}>
            <h2 style={styles.mainTitle}>{t.welcomeBack}</h2>
            <p style={styles.mainSubtitle}>{t.quickGenerateSubtitle}</p>
            <div style={styles.quickProfileCard}>
              <div style={styles.quickProfileRow}>
                <span style={styles.quickProfileLabel}>{t.quickIndustryLabel}</span>
                <span style={styles.quickProfileValue}>{industry}</span>
              </div>
              <div style={styles.quickProfileRow}>
                <span style={styles.quickProfileLabel}>{t.quickRoleLabel}</span>
                <span style={styles.quickProfileValue}>{jobTitle}</span>
              </div>
            </div>
            <button style={styles.submitButton} onClick={handleSubmit} disabled={loading}>
              {loading ? t.generatingButton : t.generateButton}
            </button>
            <div>
              <button type="button" style={styles.showMoreLink} onClick={() => setEditingProfile(true)}>
                {t.editProfile}
              </button>
            </div>
            {loading && <div style={styles.loadingMessage}>{t.loadingMessage}</div>}
          </div>
          )}
          </div>

          {briefing && !loading && (
            <div className="ie-briefing-card" style={styles.briefingCard}>
              <div style={styles.briefingHeader}>
                <div style={styles.briefingTitle}>
                  {t.briefingTitle} {t.daily} {t.briefingTitleSuffix}
                </div>
                <div style={styles.briefingLogo}>{t.appTitle}</div>
              </div>
              <div>{formatBriefing(briefing, isArabic)}</div>
              <div style={styles.disclaimer}>{t.disclaimer}</div>
              <div className="ie-no-print" style={styles.actionRow}>
                <button style={styles.regenerateButton} onClick={callBriefingAPI} disabled={loading}>
                  {t.regenerate}
                </button>
                <button style={styles.pdfButton} onClick={() => window.print()}>
                  {t.downloadPdf}
                </button>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

// Department portal — the shared, no-login read view reached via the QR/link.
// Shows a picker grid of departments first, then that department's stored
// daily briefing. No personal form, no localStorage profile — just reads
// what the Worker already generated and stored for today.
function DepartmentPortal() {
  const [view, setView] = useState('picker'); // 'picker' | 'briefing'
  const [departments, setDepartments] = useState([]);
  const [deptsLoading, setDeptsLoading] = useState(true);
  const [deptsError, setDeptsError] = useState(false);
  const [briefingData, setBriefingData] = useState(null); // { text, name, date }
  const [briefingLoading, setBriefingLoading] = useState(false);
  const [briefingError, setBriefingError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/departments`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data.success) {
          setDepartments(data.departments);
        } else {
          setDeptsError(true);
        }
        setDeptsLoading(false);
      })
      .catch(() => {
        if (!cancelled) {
          setDeptsError(true);
          setDeptsLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  const openDepartment = (dept) => {
    setView('briefing');
    setBriefingData(null);
    setBriefingError(false);
    setBriefingLoading(true);
    fetch(`${API_BASE}/api/department-briefing?slug=${encodeURIComponent(dept.slug)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBriefingData(data);
        } else {
          setBriefingError(true);
        }
        setBriefingLoading(false);
      })
      .catch(() => {
        setBriefingError(true);
        setBriefingLoading(false);
      });
  };

  const backToPicker = () => {
    setView('picker');
    setBriefingData(null);
    setBriefingError(false);
  };

  const styles = {
    container: { minHeight: '100vh', backgroundColor: BRAND.paper, fontFamily: BRAND.bodyFont },
    header: { backgroundColor: BRAND.ink, padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '10px' },
    headerTitle: { color: '#FFFFFF', fontSize: '20px', fontWeight: 'bold', letterSpacing: '0.3px', margin: 0, fontFamily: BRAND.headFont },
    dot: { display: 'inline-block', width: '9px', height: '9px', borderRadius: '50%', backgroundColor: BRAND.violet },
    main: { padding: '32px 24px', maxWidth: '760px', margin: '0 auto' },
    pageTitle: { color: BRAND.ink, fontSize: '22px', fontWeight: 'bold', marginBottom: '6px', fontFamily: BRAND.headFont },
    pageSubtitle: { color: '#666666', fontSize: '14px', marginBottom: '28px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px' },
    card: { backgroundColor: '#FFFFFF', border: '1px solid #EEEEEE', borderRadius: '10px', padding: '20px', cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.04)', textAlign: 'left', fontFamily: BRAND.bodyFont },
    cardName: { color: BRAND.ink, fontSize: '15px', fontWeight: '700' },
    backLink: { background: 'transparent', border: 'none', color: BRAND.violet, fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', padding: 0, marginBottom: '20px' },
    briefingCard: { backgroundColor: '#FFFFFF', borderRadius: '8px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${BRAND.violet}`, padding: '32px', boxSizing: 'border-box' },
    briefingHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '16px', borderBottom: '2px solid #F0F0F0', flexWrap: 'wrap', gap: '8px' },
    briefingTitle: { color: BRAND.ink, fontSize: '18px', fontWeight: 'bold', margin: 0, fontFamily: BRAND.headFont },
    briefingMeta: { color: '#999999', fontSize: '12px' },
    loadingMessage: { padding: '16px', backgroundColor: '#EFECFC', borderRadius: '6px', color: BRAND.ink, fontSize: '15px', fontStyle: 'italic' },
    errorMessage: { padding: '16px', backgroundColor: '#FDEAE6', borderRadius: '6px', color: '#8A3A2C', fontSize: '14px' },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700&family=Inter:wght@400;500;600&display=swap');
      `}</style>
      <header style={styles.header}>
        <span style={styles.dot} />
        <h1 style={styles.headerTitle}>INSIGHT ENGINE</h1>
      </header>
      <main style={styles.main}>
        {view === 'picker' && (
          <>
            <h2 style={styles.pageTitle}>Choose your function</h2>
            <p style={styles.pageSubtitle}>Select your department to see today's briefing.</p>
            {deptsLoading && <div style={styles.loadingMessage}>Loading departments...</div>}
            {deptsError && <div style={styles.errorMessage}>Couldn't load the department list. Please try again shortly.</div>}
            {!deptsLoading && !deptsError && (
              <div style={styles.grid}>
                {departments.map((dept) => (
                  <button key={dept.slug} style={styles.card} onClick={() => openDepartment(dept)}>
                    <div style={styles.cardName}>{dept.name}</div>
                  </button>
                ))}
              </div>
            )}
          </>
        )}

        {view === 'briefing' && (
          <>
            <button style={styles.backLink} onClick={backToPicker}>← Back to departments</button>
            {briefingLoading && <div style={styles.loadingMessage}>Loading today's briefing...</div>}
            {briefingError && <div style={styles.errorMessage}>No briefing available yet for this department. Please check back later.</div>}
            {briefingData && !briefingLoading && (
              <div style={styles.briefingCard}>
                <div style={styles.briefingHeader}>
                  <div style={styles.briefingTitle}>{briefingData.name}</div>
                  <div style={styles.briefingMeta}>{briefingData.date}</div>
                </div>
                <div>{formatBriefing(briefingData.text, false)}</div>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default function App() {
  const isDepartmentPortal = typeof window !== 'undefined' && window.location.pathname.startsWith('/departments');
  if (isDepartmentPortal) {
    return <DepartmentPortal />;
  }
  return <PersonalApp />;
}